import { createContext, useContext } from 'react';
import { useWebSocket as useWebSocketHook } from '../hooks/useWebSocket';

const WebSocketContext = createContext(null);

export function WebSocketProvider({ children }) {
  // WebSocket hook now checks authentication internally
  const ws = useWebSocketHook();

  return (
    <WebSocketContext.Provider value={ws}>
      {children}
    </WebSocketContext.Provider>
  );
}

export function useWebSocket() {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocket must be used within WebSocketProvider');
  }
  return context;
}
